import { render, staticRenderFns } from "./RetourForm.vue?vue&type=template&id=3e2552b8&scoped=true&lang=true"
import script from "./RetourForm.vue?vue&type=script&lang=js"
export * from "./RetourForm.vue?vue&type=script&lang=js"
import style0 from "./RetourForm.vue?vue&type=style&index=0&id=3e2552b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2552b8",
  null
  
)

export default component.exports